export const enum STORAGE_KEY {
  ACCESS_TOKEN = 'access_token',
  ROLE = 'role',
  CASE = 'case',
  TOKEN = 'token',
  LAST_PAGE_VISITED = 'last_page_visited',
  FIREBASE_AUTH_ID = 'firebase_auth_id',
  IGNORE_STATE_CHANGE = 'ignore_state_change',
  RGISTER_MUSIC_ARTIST = 'register_music_artist',
  PENDING_SUBSCRIPTION_ID = 'pending_subscription_id',
  STRIPE_ONBOARDING_URL = 'stripe_onboarding_url',
  SUBSCRIPTION_MODAL_REDIRECT = 'subscription_modal_redirect',
  SUBSCRIPTION_REDIRECT_REASON = 'subscription_redirect_reason'
}

type StorageScope = "session" | "local";

const getScopedStorage = (scope: StorageScope) => {
  if (typeof window === "undefined") return undefined;
  return scope === "local" ? localStorage : sessionStorage;
};

export const onSetStorageItem = (
  key: STORAGE_KEY,
  value: string,
  scope: StorageScope = "session"
) => {
  getScopedStorage(scope)?.setItem(key, value);
};

export const onGetStorageItem = (key: STORAGE_KEY) => {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(key) ?? localStorage.getItem(key) ?? null;
};

export const onClearStorage = () => {
  if (typeof window === "undefined") return;
  sessionStorage.clear();
  localStorage.removeItem(STORAGE_KEY.TOKEN);
  localStorage.removeItem(STORAGE_KEY.ACCESS_TOKEN);
};

export const onRemoveStorageItem = (key: STORAGE_KEY) => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
};

export const onGetAllStorageData = () => {
  const storage = getScopedStorage("session");
  if (!storage) return [];
  return Array.from({ length: storage.length }, (_, index) => {
    const key = storage.key(index);
    return {
      key,
      value: key ? storage.getItem(key) : null,
    };
  });
};
